<div class="container">
  <mat-select class="select-style" placeholder="Pick a provider"
  [(ngModel)]="selected" >
  <mat-option *ngFor="let provider of providers" [value]="provider.id">
    {{provider.name.savedValue}}
  </mat-option>
</mat-select>
<button mat-raised-button color="primary" class="clean-it-button" (click)="cleanIt()">Clean it!</button>

</div>
